// Scribe Action

// Set Scribe Active Action
export const SET_SCRIBE_ACTIVE = "SET_SCRIBE_ACTIVE";
export const SET_SCRIBE_ACTIVE_SUCCESS = "SET_SCRIBE_ACTIVE_SUCCESS";
export const SET_SCRIBE_ACTIVE_FAILURE = "SET_SCRIBE_ACTIVE_FAILURE";

// Show Application wide Help Icons
export const SHOW_HELP_ICONS = "SHOW_HELP_ICONS";
export const SHOW_HELP_ICONS_SUCCESS = "SHOW_HELP_ICONS_SUCCESS";
export const SHOW_HELP_ICONS_FAILURE = "SHOW_HELP_ICONS_FAILURE";
